// SPDX-FileCopyrightText: 2026 ParzLabs and Diffclaw contributors
// SPDX-License-Identifier: AGPL-3.0-only

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import "./styles.css";

const root = document.querySelector("#root");
if (root === null) {
  throw new TypeError("Cockpit root element is missing");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
